import { actionTypes } from '../actions/data'

function sort_objects(order, unsortedArray) {
  let newArray = Array()
  let copy = [...unsortedArray]
  for (let i = 0; i < order.length; i++) {
    for (let j = 0; j < copy.length; j++) {
      if (copy[j].tierTwo === order[i]) {
        newArray.push(copy[j])
        // break
      }
    }
  }
  return newArray
}
// DEFAULT STATE
export const initData = {
  levels: [],
  earningsType: 'growth-all', //growth/ surprise
  // growthType: "growthall",
  // constituentNumber: "10",
  periodicity: 'Quarterly',
  selectedPeriodOption: [],
  selectedRangeOption: [],
  selectedEntityOption: [],
  rangeOption: [],
  periodOption: [],
  selectedChars: '',
  initialLoad: true
}

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PERFORMANCE:
      //let periodicity = state.periodicity

      let earningsAggs = []
      earningsAggs = action.value.earningsAggs
      earningsAggs.map(function (obj) {
        if (obj.periodEnd !== null) {
          let dateArray = obj.periodEnd.split('-')
          var year = dateArray[0]
          let month = parseInt(dateArray[1], 10)
          let date = dateArray[2]
          if (date < 10) {
            date = '0' + date
          }
          if (month < 10) {
            month = `0${month}`
          }
          var format1 = month + '/' + date + '/' + year
          var format2 = month + '/' + date

          let isQtr = isNaN(obj.periodTag)
          var displayR = '  '
          if (obj.tierTwo === 'index') {
            obj.tierTwo = 'Index';
          }
          if (obj.tierOne === 'all') {
            obj.tierOne = 'All';
          }

          if (isQtr === false) {
            if (obj.periodicity === 'Annual') {
              displayR = 'A-' + obj.periodTag
            } else if (obj.periodicity === 'Semi-Annual') {
              displayR = 'SA-' + obj.periodTag
            }
          }
          //checkingendDate
          if (isQtr === true) {
            if (format2 === '11/15') {
              displayR = 'Q3' + '-' + year
            } else if (format2 === '08/15') {
              displayR = 'Q2' + '-' + year
            } else if (format2 === '05/15') {
              displayR = 'Q1' + '-' + year
            } else if (format2 === '02/15') {
              displayR = 'Q4' + '-' + (year - 1)
            }
            //cloogie offset for year data until VC fixes
          } else if (isQtr === false) {
            if (obj.periodicity === 'Annual' && format2 === '02/15') {
              displayR = 'A-' + (year - 1)
            }
          }

          obj.displayRange = displayR
          obj.periodEndD = format1
        }
        if (obj.periodStart !== null) {
          let dateArray = obj.periodStart.split('-')
          let year = dateArray[0]
          let month = parseInt(dateArray[1], 10)
          let date = dateArray[2]
          if (date < 10) {
            date = '0' + date
          }
          if (month < 10) {
            month = `0${month}`
          }
          let format1 = month + '/' + date + '/' + year

          obj.periodStartD = format1
        }
        obj.entity = obj.ticker + '-' + obj.entityName
      })

      let filteredDisplay = earningsAggs.filter(x => x.periodicity === state.periodicity)
      const rangeOption = filteredDisplay.map(item => item.displayRange).filter((value, index, self) => self.indexOf(value) === index)

      const uniquePdStart = filteredDisplay.map(item => item.periodStartD).filter((value, index, self) => self.indexOf(value) === index)
      const uniquePdEnd = filteredDisplay.map(item => item.periodEndD).filter((value, index, self) => self.indexOf(value) === index)

      // let itemIndex = filteredDisplay.findIndex(item => item.tierTwo === 'Index')
      // detach the item and return it
      //  filteredDisplay.splice(0, 0, filteredDisplay.splice(itemIndex, 1)[0])
      let order = ['Index', 'Communication Services', 'Consumer Discretionary', 'Consumer Staples', 'Energy', 'Financials', 'Health Care', 'Industrials', 'Information Technology', 'Materials', 'Real Estate', 'Utilities']
      let sortedData = filteredDisplay.filter(x => x.periodStartD === uniquePdStart[0])
      let orderedD = sort_objects(order, sortedData)
      let selectedRangeOption = orderedD[0].displayRange
      let selectedEntityOption = orderedD[0].ticker + ' - ' + orderedD[0].entityName
      let selectedPeriodOption = orderedD[0].periodicity

      return Object.assign({}, state, {
        earningsAggsAll: earningsAggs,
        earningsAggs: orderedD,
        selectedEntityOption: [selectedEntityOption],
        selectedPeriodOption: [selectedPeriodOption],
        selectedRangeOption: [selectedRangeOption],
        earningsConstituents: action.value.earningsConstituents,
        earningsTickerListing: action.value.earningsTickerListing,
        earningsStart: uniquePdStart,
        earningsEnd: uniquePdEnd,
        rangeOption: rangeOption,
        initialLoad: true
      })
    case actionTypes.SET_ENTITY:
      const entity = action.value
      return Object.assign({}, state, {
        selectedEntityOption: [entity]
      })
    case actionTypes.SET_RANGE:
      const range = action.value
      let filteredRange = state.earningsAggsAll
      filteredRange = filteredRange.filter(x => x.displayRange === range)
      return Object.assign({}, state, {
        earningsAggs: filteredRange
      })
    case actionTypes.SET_EARNINGS_TYPE:
      return Object.assign({}, state, {
        earningsType: action.payload
      })
    case actionTypes.SET_GROWTH_TYPE:
      return Object.assign({}, state, {
        growthType: action.payload
      })
    case actionTypes.SET_CONSTITUENT_NUMBER:
      return Object.assign({}, state, {
        constituentNumber: action.payload
      })
    case actionTypes.SET_PERIOD:
      let period = action.value
      return Object.assign({}, state, {
        selectedPeriodOption: [period]
      })
    case actionTypes.SET_RANGE_OPTIONS:
      let filtered = state.earningsAggsAll
      let trigers = action.value.split('_')
      let trigger = trigers[0]
      let rangeVal = trigers[1]
      let periodVal = state.selectedPeriodOption
      let selRangeValue = []
      let pd = periodVal[0]
      let rangeOptions = []
      // check what type of trigger

      if (trigger === 'range') {
        //generate all range options first
        filtered = filtered.filter(x => x.periodicity === pd)
        rangeOptions = filtered.map(item => item.displayRange).filter((value, index, self) => self.indexOf(value) === index)
        // now filter by exact ranges
        filtered = filtered.filter(x => x.displayRange === rangeVal)
        selRangeValue = rangeVal
      }

      if (trigger === 'period') {
        filtered = filtered.filter(x => x.periodicity === pd)
        //regen options
        rangeOptions = filtered.map(item => item.displayRange).filter((value, index, self) => self.indexOf(value) === index)

        //load default - latest data
        let startD = filtered.map(item => item.periodStartD).filter((value, index, self) => self.indexOf(value) === index)
        //let endD = filtered.map(item => item.periodEndD).filter((value, index, self) => self.indexOf(value) === index)
        //filter based on startD
        filtered = filtered.filter(x => x.periodStartD === startD[0])
        selRangeValue = rangeOptions[0]
      }
      return Object.assign({}, state, {
        earningsAggs: filtered,
        rangeOption: rangeOptions,
        selectedRangeOption: [selRangeValue],
        showing: false
      })

    case actionTypes.SET_SELECTED_CHARS:
      const char = action.payload
      let clonedObjArray = [...state.selectedChars]
      let index = clonedObjArray.findIndex(x => x === char)
      if (index === -1) {
        clonedObjArray.push(action.payload)
      } else {
        clonedObjArray.splice(index, 1)
      }
      return Object.assign({}, state, {
        selectedChars: action.payload
      })

    case actionTypes.RESET_LOAD_STATUS:
      const reloadStatus = action.value
      return Object.assign({}, state, {
        initialLoad: reloadStatus
      })

    default:
      return state
  }
}
// READS
export const getEarData = state => state.data
export const getConstituents = state => state.data.earningsConstituents
export const getAggs = state => state.data.earningsAggs
export const getTickerListing = state => state.data.earningsTickerListing
export const getEntityOption = state => {
  let tickerListing = state.data.earningsTickerListing
  let entities = []

  if (tickerListing) {
    for (var j = 0; j < tickerListing.length; j++) {
      let entity = tickerListing[j].ticker + ' - ' + tickerListing[j].name

      entities.push(entity)
    }
  }
  return entities.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getRangeOption = state => {
  // let earningsStart = state.data.earningsStart
  // let earningsEnd = state.data.earningsEnd
  let earningsAggsAll = state.data.earningsAggsAll

  //let selectedPeriodicity = state.data.selectedPeriodOption === undefined ? state.data.periodicity : state.data.selectedPeriodOption
  let periodicityFilter = state.data.selectedPeriodOption[0]

  var ranges = []
  if (earningsAggsAll) {
    let filteredData = earningsAggsAll.filter(x => {
      return x.periodicity === state.data.selectedPeriodOption[0]
    })

    // const displayRanges = filteredData.map(item => item.displayRange).filter((value, index, self) => self.indexOf(value) === index)
    const earningsStart = filteredData.map(item => item.periodStartD).filter((value, index, self) => self.indexOf(value) === index)
    const earningsEnd = filteredData.map(item => item.periodEndD).filter((value, index, self) => self.indexOf(value) === index)

    if (filteredData) {
      for (var j = 0; j < earningsEnd.length; j++) {
        let dateParts = earningsEnd[j].split('/')
        let year = dateParts[2]
        // let month = dateParts[0]
        // let day = dateParts[1]
        let pd = ''
        if (periodicityFilter === 'Annual') {
          pd = 'A'
        } else {
          if (earningsStart[j].substring(0, 5) === '11/16') pd = 'Q4'
          else if (earningsStart[j].substring(0, 5) === '08/16') pd = 'Q3'
          else if (earningsStart[j].substring(0, 5) === '05/16') pd = 'Q2'
          else if (earningsStart[j].substring(0, 5) === '02/16') pd = 'Q1'
        }
        let range = pd + '-' + (year - 1)
        ranges.push(range)
      }
    }
  }

  return ranges.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getPeriodOption = state => {
  let earningsAggsAll = state.data.earningsAggsAll
  let periods = ''
  if (earningsAggsAll) {
    periods = earningsAggsAll.map(item => item.periodicity).filter((value, index, self) => self.indexOf(value) === index)
  }
  return periods
}
export const getConstituentNum = state => state.data.constituentNumber
export const getEarningsPeriod = state => state.data.period
export const getEarningsType = state => state.data.earningsType
export const getGrowthType = state => state.data.growthType
export const getSelectedEntityOption = state => state.data.selectedEntityOption
export const getSelectedRangeOption = state => state.data.selectedRangeOption
export const getSelectedPeriodOption = state => state.data.selectedPeriodOption
export const getSelectedChars = state => state.data.selectedChars
export const getInitialLoad = state => state.performers.initialLoad
//export const getRangeOptions = state => state.data.rangeOptions
export default data



// WEBPACK FOOTER //
// ./src/reducers/data.js